/* eslint-disable no-lone-blocks */
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {startLoadding, stopLoading} from '../FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../Utils/_helpers/EnvHelper'

const initialState = {
  ProfileData: {},
  dedicatedNumbers: [],
  businessName: [],
  customNumbers: [],
  userOnboarding: [],
  userSubscriptions: [],
}
const API_URL = ENV().REACT_APP_API_URL

export const ProfileDetailData: any = createAsyncThunk(
  '/GetProductList',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}user/getuserdetails/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const GetUserData: any = createAsyncThunk(
  '/getSpecificUser',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}user/getuserdetails/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const WhiteLabelProfileData: any = createAsyncThunk(
  '/WhiteLabelProfileData',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}admin/getWhiteLabelWithId/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const DedicatedNumbersData: any = createAsyncThunk(
  '/DedicatedNumbersData',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}admin/get-dedicated-number/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const BusinessNameData: any = createAsyncThunk(
  '/BusinessNameData',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}admin/business/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const CustomNumbersData: any = createAsyncThunk(
  '/CustomNumbersData',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}admin/customNumber/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const GetUserOnboarding: any = createAsyncThunk(
  '/UserOnboarding',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}user/onboarding/view/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const GetUserSubscriptions: any = createAsyncThunk(
  '/GetUserSubscriptions',
  async (args: {userId: string; page?: number; limit?: number} | string, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const userId = typeof args === 'string' ? args : args.userId
    const page = typeof args === 'string' ? undefined : args.page
    const limit = typeof args === 'string' ? undefined : args.limit

    const response: any = await axios.get(`${API_URL}products/admin/subscriptions-list/${userId}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      params: {
        page,
        limit,
      },
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const ProfileDetailDataOfUser = createSlice({
  name: 'signIn',
  initialState,
  reducers: {},
  extraReducers: {
    [ProfileDetailData.fulfilled]: (state, {payload}) => {
      return {...state, ProfileData: payload.data}
    },
    [WhiteLabelProfileData.fulfilled]: (state, {payload}) => {
      return {...state, ProfileData: payload.data}
    },
    [DedicatedNumbersData.fulfilled]: (state, {payload}) => {
      return {...state, dedicatedNumbers: payload.data}
    },
    [BusinessNameData.fulfilled]: (state, {payload}) => {
      return {...state, businessName: payload.data}
    },
    [CustomNumbersData.fulfilled]: (state, {payload}) => {
      return {...state, customNumbers: payload.data}
    },
    [GetUserOnboarding.fulfilled]: (state, {payload}) => {
      return {...state, userOnboarding: payload.data}
    },
    [GetUserSubscriptions.fulfilled]: (state, {payload}) => {
      return {...state, userSubscriptions: payload.data}
    },
  },
})

export const AdminProfileDataOnUpdate = (state: any) => state?.ProfileData?.ProfileData

export default ProfileDetailDataOfUser.reducer
